/**
 * Formats a duration in milliseconds into a human-readable string.
 * Examples: "2h 15m", "45m", "30s", "—"
 */
export function formatDuration(ms: number | undefined | null): string {
  if (!ms || ms < 1000) return "—";

  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
  if (minutes > 0) {
    return `${minutes}m`;
  }
  return `${seconds}s`;
}
